import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Multibrand-UI Components
import Modal from '@zg-rentals/multibrand-ui/lib/Modal';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import ModalActions from 'app/shared/actions/ModalActions';
import ModalConstants from 'app/shared/constants/ModalConstants';

// style
import './style.scss';

class VerifyEmailFailureModal extends React.Component {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);

        // init state
        this.state = {
            isOpen: this.props.isOpen,
        };

        // bind
        this.modalClose = this.modalClose.bind(this);
        this.modalOpen = this.modalOpen.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.isOpen !== this.state.isOpen)) {
            this.setState({ isOpen: nextProps.isOpen });
        }
    }

    modalClose() {
        this.props.dispatch(ModalActions.updateDisplayVerifyEmailFailureModal({ isOpen: false }));
    }

    modalOpen() {
        this.props.dispatch(ModalActions.updateDisplayVerifyEmailFailureModal({ isOpen: true }));
    }

    render() {
        const { isOpen } = this.state;
        const parentSelector = ModalConstants.MODAL_PARENT_SELECTOR;

        return (
            <Modal
                className="VerifyEmailFailureModal"
                isOpen={isOpen}
                parentSelector={this.parentSelector}
                shouldBypassBodyStyling={true}
                onRequestClose={this.modalClose}
                header="Error"
                isWizard={true}
                id={parentSelector}
            >
                <div className="VerifyEmailFailureModal-content">
                    <SpacerRow>
                        <Text type="h3">
                            Incorrect account
                        </Text>
                    </SpacerRow>

                    <SpacerRow>
                        <Text type="body">
                            This account doesn’t match account provided on listing.
                            For additional help or questions, please contact customer support.
                        </Text>
                    </SpacerRow>
                </div>
            </Modal>
        );
    }
}

export { VerifyEmailFailureModal };
export default connect()(VerifyEmailFailureModal);
